<script lang="ts">
const __DsBlock = {
	name: '$t:blocks.cards.name',
	icon: 'lucide:layout-grid',
	category: 'layout',
	type: 'listing-layout',
	hidden: true,
	events: [
		{
			name: 'open',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
		{
			name: 'update:displayOptions',
			payload: [
				{
					name: 'value',
					type: 'object',
					array: false,
					required: true,
				},
			],
		},
	],
	slots: ['actions'],
}
</script>
<script lang="ts" setup generic="T">
import type { CompositePrimaryKey } from '#layers/data-model/public';
import type { CardsDisplayOptions, SharedLayoutEmits, SharedLayoutProps } from '#layers/listing/public';
import { defineBlock } from '#layers/block-engine/public';
import RenderDisplayTemplate from '#layers/blocks/components/Render/RenderDisplayTemplate.vue';
import { useForwardedLayoutEmits } from '#layers/blocks/composables/use-forwarded-layout-emits';
import { LayoutCards } from '#layers/listing/public';

interface LayoutCardsBlockProps extends SharedLayoutProps<CardsDisplayOptions> {}

defineProps<LayoutCardsBlockProps>();

const emit = defineEmits<SharedLayoutEmits>();

const selection = defineModel<CompositePrimaryKey[]>('selection', { default: () => [] });

const forwardedEmits = useForwardedLayoutEmits<SharedLayoutEmits>(emit);

;
</script>

<template>
	<LayoutCards
		v-bind="{ ...$props, ...forwardedEmits }"
		v-model:selection="selection"
		:render-display-template="RenderDisplayTemplate"
	/>
</template>
